export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      screenConfigMst: {
        screenConfigMstId: 1,
        screenConfigMstUuid: "screenconfigmst001",
        screenConfigName: "コミュニティサポート系トップ画面",
        deviceTypeUuid: "device002",
        deviceTypeName: "XXXXBOX",
        serviceTypeKbn: 1,
        serviceTypeName: "コミュニティサポート系",
        screenOrientationKbn: 1,
        screenConifgStatus: 1,
        screenWidth: 1280,
        screenHeight: 800
      }
    }
  }
}